$(document).on('ready', () => {

    /*
        * Toggles mobile navigation
        * */
    $('.hamburger-menu').on('click', function (e) {
        $('.panel-wrap-2').toggleClass('open-panel', 'close-panel');
    });

});


// WEBPACK FOOTER //
// ./resources/assets/js/Navigation.js